export function normTimelineId(v) {
	if (v == null || v === '') return '';
	return String(v);
}
